export default __webpack_public_path__ + "static/media/28.bc339e5e.png";